<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MFlHKb/tc-custom/9781781597231.jpg?1728726247405" alt="This image is the cover for the book Malta Besieged, 1940–1942, Campaign Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Malta Besieged, 1940–1942, Campaign Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This WWII military study sheds new light on the legendary Siege of Malta, combining a detailed narrative with provocative strategic analysis.</b><br/><br/> The heroic defense of Malta against the Axis powers is one of the most famous episodes of the Second World War. For more than two years this tiny island was the critical to maintaining control of the Mediterranean and essential to the outcome of the North African campaign. David Williamson, in this thought-provoking reassessment, examines the strategy underpinning British determination to hold on to the island.<br/><br/> Expertly researched and vividly detailed, <i>Malta Besieged</i> sheds new light on the motives for persisting with such a costly defense against huge odds. he also explores the question of the islanders’ loyalty to the British crown. His incisive analysis takes account of the tactics employed by both sides, the political thinking and decision-making at the highest levels and the grim reality of the destruction and suffering on the ground. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David G. Williamson
      </h2>
      
      <p class="authorDescription body article">David G. Williamson is also the author of The Siege of Malta (978-1-84415-477-7). He lives in England. --This text refers to an out of print or unavailable edition of this title.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0c2e17e1